import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { NavigationInfoSymbol } from '@wix/thunderbolt-symbols'
import { EditorNavigation } from './editorNavigation'
import { EditorNavigationSymbol, IsDuringNavigationInteractionSymbol } from './symbols'
import type { IEditorNavigation, INavigationInfo, IIsDuringNavigationInteraction } from './types'
import { NavigationInfo } from './navigationInfo'
import { IsDuringNavigationInteraction } from './isDuringNavigationInteraction'

export const editor: ContainerModuleLoader = (bind) => {
	bind(IsDuringNavigationInteractionSymbol).to(IsDuringNavigationInteraction)
	bind(EditorNavigationSymbol).to(EditorNavigation)
	bind(NavigationInfoSymbol).to(NavigationInfo)
}

// Public Symbols
export { EditorNavigationSymbol, IsDuringNavigationInteractionSymbol }

// Public Types
export { IEditorNavigation, INavigationInfo, IIsDuringNavigationInteraction }
